// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a17cb542","455":"e78d7944","977":"03be1a4d"}[chunkId] + ".chunk.js";
};